import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { useTranslate } from '../../../../translations/hooks/useTranslate';
import { selectTrainingsList } from '../../redux/selectors';
import { useStyles } from './styles';
import { TrainingListItem } from '../TrainingCard';

export const TrainingsList: React.FC = () => {
  const t = useTranslate();
  const styles = useStyles();
  const trainings = useSelector(selectTrainingsList);

  return (
    <Box className={styles.container}>
      <Typography variant="h6" className={styles.heading}>
        {t('wiki.trainings-list.title')}
      </Typography>
      {trainings.map(t => (
        <TrainingListItem key={t.id} training={t} />
      ))}
    </Box>
  );
};
